import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BiLogInCircle } from 'react-icons/bi';

import Spinner from '../components/Spinner';

import { useAuthContext } from '../hooks/useAuthContext';
import { useSignup } from '../hooks/useSignup';

export default function Signup() {
  const [fullname, setFullname] = useState('')
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { signup, isLoading, error } = useSignup()
  const { authUser } = useAuthContext()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()

    await signup(fullname, username, email, password)
  }

  if (authUser) navigate('/')

  return (
    <div className="d-flex justify-content-center align-items-center " style={{ height: '100vh' }}>
      {isLoading ? (
        <Spinner marginSize='100px' />
      ) : (
        <div className="d-flex row justify-content-between align-items-center rounded border border-2 border-violet shadow-lg p-3 mb-5">
          <form className="p-4" onSubmit={handleSubmit}>
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control border rounded border-violet"
                onChange={(e) => setFullname(e.target.value)}
                value={fullname}
                id="floatingFullname"
                placeholder="fullname"
              />
              <label htmlFor="floatingFullname">Fullname</label>
            </div>

            <div className="form-floating mb-3 has-danger">
              <input
                type="text"
                className={`form-control border rounded ${error && error === 'Username is already taken' ?
                    'border-danger is-invalid' : 'border-violet'
                  }`}
                onChange={(e) => setUsername(e.target.value)}
                value={username}
                id="floatingUsername"
                placeholder="username"
              />
              <label htmlFor="floatingUsername">Username</label>
            </div>

            <div className="form-floating mb-3 has-danger">
              <input
                type="email"
                className={`form-control border rounded ${error && (error === 'Invalid email format' || error === 'Email is already taken') ?
                    'border-danger is-invalid' : 'border-violet'
                  }`}
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                id="floatingEmail"
                placeholder="name@example.com"
              />
              <label htmlFor="floatingEmail">Email address</label>
            </div>

            <div className="form-floating mb-3 has-danger">
              <input
                type="password"
                className={`form-control border rounded ${error && error === 'Password must be at least 6 characters long!' ?
                    'border-danger is-invalid' : 'border-violet'
                  }`}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                id="floatingPassword"
                placeholder="Password"
                autoComplete="off"
              />
              <label htmlFor="floatingPassword">Password</label>
            </div>

            <div className="text-center mb-3">
              <button className="btn btn-violet" disabled={isLoading}>
                <div className='d-flex justify-content-center align-items-center'>
                  <BiLogInCircle />
                  <span className='mx-1'>Signup</span>
                </div>
              </button>
            </div>

            {error &&
              <div className="alert alert-dismissible alert-danger text-center">
                <strong>{error}</strong>
              </div>
            }
          </form>
          <p className="text-center mb-10">
            Signed up before?, just <Link to="/login" className="text-violet cursor-pointer">Login</Link>
          </p>
        </div>
      )}
    </div>
  )
}
